import Immutable from 'immutable';

export function listToJSArray<TList, TArray>(list: Immutable.List<TList>): TArray {
  return list.toJS() as unknown as TArray;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function recordToJSObject<TObject>(record: Immutable.Record<any>): TObject {
  return record.toJS() as unknown as TObject;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function recordExtensionToJSObject<TRecord extends Immutable.Record<any>, TObject>(
  recordExtension: TRecord
): TObject {
  return recordExtension.toJS() as unknown as TObject;
}
